var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11623",
    "data-name": "Group 11623",
    transform: "translate(0 -0.465)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_177",
    "data-name": "Ellipse 177",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(0 0.465)",
    fill: "#fff",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11622",
    "data-name": "Group 11622",
    transform: "translate(3.5 1.965)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_695",
    "data-name": "Line 695",
    y2: 10,
    transform: "translate(5.5 2.5)",
    fill: "none",
    stroke: "#cbc3d6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_696",
    "data-name": "Line 696",
    x1: 10,
    transform: "translate(0.5 7.5)",
    fill: "none",
    stroke: "#cbc3d6",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.555c93d09684122d0d38743355496d4f.svg";
export { ForwardRef as ReactComponent };